import { render, staticRenderFns } from "./clipboardPic.vue?vue&type=template&id=48aa33ca&"
import script from "./clipboardPic.vue?vue&type=script&lang=js&"
export * from "./clipboardPic.vue?vue&type=script&lang=js&"
import style0 from "./clipboardPic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports